/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_One_Drive_List_ErrorInputs */

const es_tools_one_drive_list_error = /** @type {(inputs: Tools_One_Drive_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al listar OneDrive`)
};

const en_tools_one_drive_list_error = /** @type {(inputs: Tools_One_Drive_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error listing OneDrive`)
};

/**
* | output |
* | --- |
* | "Error listing OneDrive" |
*
* @param {Tools_One_Drive_List_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_one_drive_list_error = /** @type {((inputs?: Tools_One_Drive_List_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_One_Drive_List_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_one_drive_list_error(inputs)
	return en_tools_one_drive_list_error(inputs)
});
export { tools_one_drive_list_error as "tools.one_drive.list_error" }